/**
 * What an authenticated user sees when the system has not been configured.
 *
 * Only an admin can act on the first-run setup page: every write behind it
 * (/api/secrets/set, /api/secrets/test, /api/admin/reload-all) requires the
 * admin role on the backend. Anyone else gets the normal app with a notice.
 *
 * - 'setup'  — render the ConfigurationPage (admin, unconfigured)
 * - 'notice' — render the app shell with the "not configured" notice
 * - 'none'   — render the app shell as usual (configured, status still
 *              loading, or the role is not known yet — the profile has not
 *              loaded, so neither the setup page nor the notice is shown)
 */
export type SetupGate = 'setup' | 'notice' | 'none';

export function setupGate(configured: boolean | null, role: string | null | undefined): SetupGate {
  if (configured !== false) return 'none';
  if (!role) return 'none';
  return role === 'admin' ? 'setup' : 'notice';
}

/** How often a shown "not configured" notice re-checks the system status. */
export const CONFIG_RECHECK_MS = 30_000;
